/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as CenterRouteImport } from './routes/center'
import { Route as DeskRouteImport } from './routes/desk'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as AppTabsRouteImport } from './routes/_app/_tabs'
import { Route as AppExportRouteImport } from './routes/_app/export'
import { Route as AppIdCardsRouteImport } from './routes/_app/id-cards'
import { Route as AppTeamRouteImport } from './routes/_app/team'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as AppTabsHubRouteImport } from './routes/_app/_tabs/hub'
import { Route as AppTabsMeRouteImport } from './routes/_app/_tabs/me'
import { Route as AppTabsStudentsRouteImport } from './routes/_app/_tabs/students'
import { Route as AppTabsTimelineRouteImport } from './routes/_app/_tabs/timeline'
import { Route as AppCheckinStudentIdRouteImport } from './routes/_app/checkin.$studentId'
import { Route as AppGroupsNewRouteImport } from './routes/_app/groups.new'
import { Route as AppRollcallGroupIdRouteImport } from './routes/_app/rollcall.$groupId'
import { Route as AppStudentStudentIdRouteImport } from './routes/_app/student.$studentId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const CenterRoute = CenterRouteImport.update({
  id: '/center',
  path: '/center',
  getParentRoute: () => rootRouteImport,
} as any)
const DeskRoute = DeskRouteImport.update({
  id: '/desk',
  path: '/desk',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const AppTabsRoute = AppTabsRouteImport.update({
  id: '/_tabs',
  getParentRoute: () => AppRoute,
} as any)
const AppExportRoute = AppExportRouteImport.update({
  id: '/export',
  path: '/export',
  getParentRoute: () => AppRoute,
} as any)
const AppIdCardsRoute = AppIdCardsRouteImport.update({
  id: '/id-cards',
  path: '/id-cards',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamRoute = AppTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppTabsHubRoute = AppTabsHubRouteImport.update({
  id: '/hub',
  path: '/hub',
  getParentRoute: () => AppTabsRoute,
} as any)
const AppTabsMeRoute = AppTabsMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => AppTabsRoute,
} as any)
const AppTabsStudentsRoute = AppTabsStudentsRouteImport.update({
  id: '/students',
  path: '/students',
  getParentRoute: () => AppTabsRoute,
} as any)
const AppTabsTimelineRoute = AppTabsTimelineRouteImport.update({
  id: '/timeline',
  path: '/timeline',
  getParentRoute: () => AppTabsRoute,
} as any)
const AppCheckinStudentIdRoute = AppCheckinStudentIdRouteImport.update({
  id: '/checkin/$studentId',
  path: '/checkin/$studentId',
  getParentRoute: () => AppRoute,
} as any)
const AppGroupsNewRoute = AppGroupsNewRouteImport.update({
  id: '/groups/new',
  path: '/groups/new',
  getParentRoute: () => AppRoute,
} as any)
const AppRollcallGroupIdRoute = AppRollcallGroupIdRouteImport.update({
  id: '/rollcall/$groupId',
  path: '/rollcall/$groupId',
  getParentRoute: () => AppRoute,
} as any)
const AppStudentStudentIdRoute = AppStudentStudentIdRouteImport.update({
  id: '/student/$studentId',
  path: '/student/$studentId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/center': typeof CenterRoute
  '/desk': typeof DeskRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/welcome': typeof WelcomeRoute
  '/export': typeof AppExportRoute
  '/id-cards': typeof AppIdCardsRoute
  '/team': typeof AppTeamRoute
  '/invite/$token': typeof InviteTokenRoute
  '/hub': typeof AppTabsHubRoute
  '/me': typeof AppTabsMeRoute
  '/students': typeof AppTabsStudentsRoute
  '/timeline': typeof AppTabsTimelineRoute
  '/checkin/$studentId': typeof AppCheckinStudentIdRoute
  '/groups/new': typeof AppGroupsNewRoute
  '/rollcall/$groupId': typeof AppRollcallGroupIdRoute
  '/student/$studentId': typeof AppStudentStudentIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/center': typeof CenterRoute
  '/desk': typeof DeskRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/welcome': typeof WelcomeRoute
  '/export': typeof AppExportRoute
  '/id-cards': typeof AppIdCardsRoute
  '/team': typeof AppTeamRoute
  '/invite/$token': typeof InviteTokenRoute
  '/hub': typeof AppTabsHubRoute
  '/me': typeof AppTabsMeRoute
  '/students': typeof AppTabsStudentsRoute
  '/timeline': typeof AppTabsTimelineRoute
  '/checkin/$studentId': typeof AppCheckinStudentIdRoute
  '/groups/new': typeof AppGroupsNewRoute
  '/rollcall/$groupId': typeof AppRollcallGroupIdRoute
  '/student/$studentId': typeof AppStudentStudentIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/center': typeof CenterRoute
  '/desk': typeof DeskRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/welcome': typeof WelcomeRoute
  '/_app/_tabs': typeof AppTabsRouteWithChildren
  '/_app/export': typeof AppExportRoute
  '/_app/id-cards': typeof AppIdCardsRoute
  '/_app/team': typeof AppTeamRoute
  '/invite/$token': typeof InviteTokenRoute
  '/_app/_tabs/hub': typeof AppTabsHubRoute
  '/_app/_tabs/me': typeof AppTabsMeRoute
  '/_app/_tabs/students': typeof AppTabsStudentsRoute
  '/_app/_tabs/timeline': typeof AppTabsTimelineRoute
  '/_app/checkin/$studentId': typeof AppCheckinStudentIdRoute
  '/_app/groups/new': typeof AppGroupsNewRoute
  '/_app/rollcall/$groupId': typeof AppRollcallGroupIdRoute
  '/_app/student/$studentId': typeof AppStudentStudentIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/center'
    | '/desk'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/welcome'
    | '/export'
    | '/id-cards'
    | '/team'
    | '/invite/$token'
    | '/hub'
    | '/me'
    | '/students'
    | '/timeline'
    | '/checkin/$studentId'
    | '/groups/new'
    | '/rollcall/$groupId'
    | '/student/$studentId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/center'
    | '/desk'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/welcome'
    | '/export'
    | '/id-cards'
    | '/team'
    | '/invite/$token'
    | '/hub'
    | '/me'
    | '/students'
    | '/timeline'
    | '/checkin/$studentId'
    | '/groups/new'
    | '/rollcall/$groupId'
    | '/student/$studentId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/center'
    | '/desk'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/welcome'
    | '/_app/_tabs'
    | '/_app/export'
    | '/_app/id-cards'
    | '/_app/team'
    | '/invite/$token'
    | '/_app/_tabs/hub'
    | '/_app/_tabs/me'
    | '/_app/_tabs/students'
    | '/_app/_tabs/timeline'
    | '/_app/checkin/$studentId'
    | '/_app/groups/new'
    | '/_app/rollcall/$groupId'
    | '/_app/student/$studentId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  CenterRoute: typeof CenterRoute
  DeskRoute: typeof DeskRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignInRoute: typeof SignInRoute
  WelcomeRoute: typeof WelcomeRoute
  InviteTokenRoute: typeof InviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/center': {
      id: '/center'
      path: '/center'
      fullPath: '/center'
      preLoaderRoute: typeof CenterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desk': {
      id: '/desk'
      path: '/desk'
      fullPath: '/desk'
      preLoaderRoute: typeof DeskRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/_tabs': {
      id: '/_app/_tabs'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppTabsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/export': {
      id: '/_app/export'
      path: '/export'
      fullPath: '/export'
      preLoaderRoute: typeof AppExportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/id-cards': {
      id: '/_app/id-cards'
      path: '/id-cards'
      fullPath: '/id-cards'
      preLoaderRoute: typeof AppIdCardsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team': {
      id: '/_app/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AppTeamRouteImport
      parentRoute: typeof AppRoute
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/_tabs/hub': {
      id: '/_app/_tabs/hub'
      path: '/hub'
      fullPath: '/hub'
      preLoaderRoute: typeof AppTabsHubRouteImport
      parentRoute: typeof AppTabsRoute
    }
    '/_app/_tabs/me': {
      id: '/_app/_tabs/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof AppTabsMeRouteImport
      parentRoute: typeof AppTabsRoute
    }
    '/_app/_tabs/students': {
      id: '/_app/_tabs/students'
      path: '/students'
      fullPath: '/students'
      preLoaderRoute: typeof AppTabsStudentsRouteImport
      parentRoute: typeof AppTabsRoute
    }
    '/_app/_tabs/timeline': {
      id: '/_app/_tabs/timeline'
      path: '/timeline'
      fullPath: '/timeline'
      preLoaderRoute: typeof AppTabsTimelineRouteImport
      parentRoute: typeof AppTabsRoute
    }
    '/_app/checkin/$studentId': {
      id: '/_app/checkin/$studentId'
      path: '/checkin/$studentId'
      fullPath: '/checkin/$studentId'
      preLoaderRoute: typeof AppCheckinStudentIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/groups/new': {
      id: '/_app/groups/new'
      path: '/groups/new'
      fullPath: '/groups/new'
      preLoaderRoute: typeof AppGroupsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rollcall/$groupId': {
      id: '/_app/rollcall/$groupId'
      path: '/rollcall/$groupId'
      fullPath: '/rollcall/$groupId'
      preLoaderRoute: typeof AppRollcallGroupIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/student/$studentId': {
      id: '/_app/student/$studentId'
      path: '/student/$studentId'
      fullPath: '/student/$studentId'
      preLoaderRoute: typeof AppStudentStudentIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppTabsRouteChildren {
  AppTabsHubRoute: typeof AppTabsHubRoute
  AppTabsMeRoute: typeof AppTabsMeRoute
  AppTabsStudentsRoute: typeof AppTabsStudentsRoute
  AppTabsTimelineRoute: typeof AppTabsTimelineRoute
}

const AppTabsRouteChildren: AppTabsRouteChildren = {
  AppTabsHubRoute: AppTabsHubRoute,
  AppTabsMeRoute: AppTabsMeRoute,
  AppTabsStudentsRoute: AppTabsStudentsRoute,
  AppTabsTimelineRoute: AppTabsTimelineRoute,
}

const AppTabsRouteWithChildren =
  AppTabsRoute._addFileChildren(AppTabsRouteChildren)

interface AppRouteChildren {
  AppTabsRoute: typeof AppTabsRouteWithChildren
  AppExportRoute: typeof AppExportRoute
  AppIdCardsRoute: typeof AppIdCardsRoute
  AppTeamRoute: typeof AppTeamRoute
  AppCheckinStudentIdRoute: typeof AppCheckinStudentIdRoute
  AppGroupsNewRoute: typeof AppGroupsNewRoute
  AppRollcallGroupIdRoute: typeof AppRollcallGroupIdRoute
  AppStudentStudentIdRoute: typeof AppStudentStudentIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppTabsRoute: AppTabsRouteWithChildren,
  AppExportRoute: AppExportRoute,
  AppIdCardsRoute: AppIdCardsRoute,
  AppTeamRoute: AppTeamRoute,
  AppCheckinStudentIdRoute: AppCheckinStudentIdRoute,
  AppGroupsNewRoute: AppGroupsNewRoute,
  AppRollcallGroupIdRoute: AppRollcallGroupIdRoute,
  AppStudentStudentIdRoute: AppStudentStudentIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  CenterRoute: CenterRoute,
  DeskRoute: DeskRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInRoute: SignInRoute,
  WelcomeRoute: WelcomeRoute,
  InviteTokenRoute: InviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
